import { useDialogState } from 'reakit/Dialog';

export const useBottomDrawerUIState = () => useDialogState({ animated: true });
